<template>
  <v-layout class="layout-all" column>
    <h2>Crear Usuario</h2>
    <v-flex>
      <v-flex>
        <p>Ingrese el email del usuario que va a ser creado:</p>
      </v-flex>
      <v-form v-model="valid" ref="form" lazy-validation>
        <h3><b>Roles</b></h3>
        <p>Seleccione el rol del usuario a crear.</p>
        <v-radio-group v-model="roleSelected" :row="true">
          <v-radio
            tabindex="0"
            v-for="(role, index) in roles"
            :key="index"
            :label="role"
            :value="index"
            color="#C46D24"
          ></v-radio>
        </v-radio-group>
        <v-flex d-flex>
          <!-- LEFT -->
          <v-flex>
            <!-- EMAIL USER -->
            <VTextField
              tabindex="1"
              class="text-field-width"
              box
              clearable
              v-model="userEmailCRUD"
              label="email Usuario"
              color="#C46D24"
              :disabled="disableAll"
              required
              :rules="emailRules"
            />
            <!-- FIRSTNAME -->
            <VTextField
              tabindex="3"
              class="text-field-width"
              box
              clearable
              v-model="userFirstNameCRUD"
              label="Nombres Usuario"
              color="#C46D24"
              :disabled="disableAll"
              required
              :rules="[v => !!v || 'Item requerido']"
            />
            <!-- DOCUMENT -->
            <VTextField
              tabindex="5"
              class="text-field-width"
              box
              clearable
              v-model="userDocumentCRUD"
              label="Número de Documento"
              color="#C46D24"
              :disabled="disableAll"
              required
              :rules="[v => !!v || 'Item requerido']"
            />
            <!-- ABOUT -->
            <VTextField
              tabindex="7"
              class="text-field-width"
              box
              clearable
              v-model="userAboutCRUD"
              label="Cargo"
              color="#C46D24"
              :disabled="disableAll"
            />
            <v-flex v-if="roleSelected < 2">
              <!-- EMAIL LIDER FUNCIONAL -->
              <VTextField
                tabindex="9"
                class="text-field-width"
                box
                clearable
                v-model="userEmailLeaderCRUD"
                :value="userEmailLeaderCRUDVal"
                label="email Lider Funcional"
                color="#C46D24"
                :disabled="disableAll"
                required
                :rules="emailRules"
              />
              <!-- START DAY -->
              <v-menu
                v-model="menuStartDate"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
                color="#C46D24"
              >
                <template v-slot:activator="{ on }">
                  <VTextField
                    tabindex="11"
                    class="text-field-width"
                    v-model="userStartDayCRUD"
                    label="Fecha de Inicio - DD/MM/AAAA"
                    color="#C46D24"
                    readonly
                    v-on="on"
                    :disabled="disableAll"
                    required
                    :rules="[v => !!v || 'Item requerido']"
                  ></VTextField>
                </template>
                <v-date-picker
                  v-model="date"
                  no-title
                  color="#C46D24"
                  locale="es-co"
                  @input="menuStartDate = false"
                ></v-date-picker>
              </v-menu>
              <!-- <VTextField
                class="text-field-width"
                box
                clearable
                v-model="userStartDayCRUD"
                label="Fecha de Inicio - DD/MM/AAAA"
                color="#C46D24"
                :disabled="disableAll"
                required
                :rules="[v => !!v || 'Item requerido']"
              /> -->
              <!-- AREA -->
              <VTextField
                tabindex="13"
                class="text-field-width"
                box
                clearable
                v-model="userAreaCRUD"
                label="Area"
                color="#C46D24"
                :disabled="disableAll"
              />
            </v-flex>
          </v-flex>
          <!-- RIGHT -->
          <v-flex>
            <!-- ODS -->
            <v-select
              tabindex="2"
              v-model="odsSelected"
              class="text-field-width"
              :items="odsList"
              :multiple="roleSelected > 1"
              box
              clearable
              label="ODS"
              color="#C46D24"
              :disabled="disableAll"
              required
              :rules="[v => !!v || 'Item requerido']"
            ></v-select>
            <!-- LASTNAME -->
            <VTextField
              tabindex="4"
              class="text-field-width"
              box
              clearable
              v-model="userLastNameCRUD"
              label="Apellidos Usuario"
              color="#C46D24"
              :disabled="disableAll"
              required
              :rules="[v => !!v || 'Item requerido']"
            />
            <!-- PHONE NUMBER -->
            <VTextField
              tabindex="6"
              class="text-field-width"
              box
              clearable
              v-model="userPhoneNumberCRUD"
              label="Número de Celular"
              color="#C46D24"
              :disabled="disableAll"
            />
            <v-flex v-if="roleSelected < 2">
              <!-- VICEP -->
              <VTextField
                tabindex="8"
                class="text-field-width"
                box
                clearable
                v-model="userVicePCRUD"
                label="Vicepresidencia"
                color="#C46D24"
                :disabled="disableAll"
                required
                :rules="[v => !!v || 'Item requerido']"
              />
              <!-- EMAIL ADMINISTRADOR ODS -->
              <VTextField
                tabindex="10"
                class="text-field-width"
                box
                clearable
                v-model="userEmailAdminCRUD"
                :value="userEmailAdminCRUDVal"
                label="email Administrador ODS"
                color="#C46D24"
                :disabled="disableAll"
                required
                :rules="emailRules"
              />
              <!-- LEVEL -->
              <VTextField
                tabindex="12"
                class="text-field-width"
                box
                clearable
                v-model="userLevelCRUD"
                label="Nivel"
                color="#C46D24"
                :disabled="disableAll"
                required
                :rules="[v => !!v || 'Item requerido']"
              />
              <!-- FIELD -->
              <VTextField
                tabindex="14"
                class="text-field-width"
                box
                clearable
                v-model="userFieldCRUD"
                label="Campo"
                color="#C46D24"
                :disabled="disableAll"
              />
            </v-flex>
          </v-flex>
        </v-flex>
        <v-btn
          tabindex="15"
          class="text-capitalize"
          color="#6E8F82"
          :loading="disableAll"
          :dark="valid"
          :disabled="!valid"
          @click="createUserIn"
        >
          <font-awesome-icon
            class="mr-2"
            :style="{ color: '#FFFFFF' }"
            size="lg"
            :icon="['fal', 'user-plus']"
          />
          Crear Usuario
        </v-btn>
      </v-form>
    </v-flex>
    <!-- TO CREATE FROM LOCAL -->
    <!-- <v-flex>
      <v-btn
        color="orange white--text"
        :loading="disableAll"
        :disabled="!valid"
        @click="createUserAlt(0)"
      >
        Crear Operativos
      </v-btn>
    </v-flex> -->

    <!-- <v-flex>
      <v-btn
        color="orange white--text"
        :loading="disableAll"
        :disabled="!valid"
        @click="createUserAlt(1)"
      >
        Crear Administrativos
      </v-btn>
    </v-flex> -->

    <!-- <v-flex>
      <v-btn
        color="orange white--text"
        :loading="disableAll"
        :disabled="!valid"
        @click="createUserAlt(2)"
      >
        Crear Lideres Fun
      </v-btn>
    </v-flex> -->

    <!-- <v-flex>
      <v-btn
        color="orange white--text"
        :loading="disableAll"
        :disabled="!valid"
        @click="createUserAlt(3)"
      >
        Crear Administradores ODS
      </v-btn>
    </v-flex> -->

    <!-- <v-flex>
      <v-btn
        color="orange white--text"
        :loading="disableAll"
        :disabled="!valid"
        @click="createUserAlt(4)"
      >
        Crear Testers
      </v-btn>
    </v-flex> -->
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { odsList, odsListStaging } from "../utils/odsList";

const odsListImport =
  process.env.VUE_APP_MODE === "S" || process.env.VUE_APP_MODE === "S-Dev"
    ? odsListStaging
    : odsList;

export default {
  name: "Users",
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menuStartDate: false,
      userFieldCRUD: "",
      userAreaCRUD: "",
      userVicePCRUD: "",
      userAboutCRUD: "",
      userLevelCRUD: "",
      // userStartDayCRUD: "",
      userDocumentCRUD: "",
      userPhoneNumberCRUD: "",
      userEmailAdminCRUDVal: "",
      userEmailLeaderCRUDVal: "",
      userFirstNameCRUD: "",
      userLastNameCRUD: "",
      emailRules: [
        v => !!v || "El E-mail es requerido",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "El E-mail debe ser válido"
      ],
      valid: false,
      // roleSelected: 0,
      roles: [
        "Operativo",
        "Administrativo",
        "Lider Funcional",
        "Administrador ODS"
      ],
      // odsSelected: [],
      odsList: odsListImport
    };
  },
  filters: {
    emailToLowerCase(value) {
      return value.toLowerCase();
    }
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    roleSelected() {
      // console.log(newValue, oldValue);
      this.odsSelected = [];
      const data = {
        key: "ods",
        value: null
      };
      this.setNewUserData(data);
    }
  },
  computed: {
    ...mapGetters(["emailCRUD", "roleCRUD", "odsCRUD", "disableAll"]),
    userEmailAdminCRUD: {
      get() {
        return this.userEmailAdminCRUDVal;
      },
      set(value) {
        const result = value !== null ? value.toLowerCase() : "";
        this.userEmailAdminCRUDVal = result;
      }
    },
    userEmailLeaderCRUD: {
      get() {
        return this.userEmailLeaderCRUDVal;
      },
      set(value) {
        const result = value !== null ? value.toLowerCase() : "";
        this.userEmailLeaderCRUDVal = result;
      }
    },
    userStartDayCRUD() {
      return this.formatDate(this.date);
    },
    userEmailCRUD: {
      get() {
        return this.emailCRUD;
      },
      set(value) {
        const data = {
          key: "email",
          value: value.toLowerCase()
        };
        this.setNewUserData(data);
      }
    },
    roleSelected: {
      get() {
        return this.roleCRUD;
      },
      set(value) {
        const data = {
          key: "role",
          value: value
        };
        this.setNewUserData(data);
      }
    },
    odsSelected: {
      get() {
        return this.odsCRUD;
      },
      set(value) {
        const data = {
          key: "ods",
          value: value
        };
        this.setNewUserData(data);
      }
    }
  },
  methods: {
    ...mapActions([
      // "createUserAltA",
      "createUser",
      "setNewUserData",
      "fetchUsers"
    ]),
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    // createUserAlt(rol) {
    //   this.createUserAltA(rol);
    // },
    createUserIn() {
      if (this.$refs.form.validate()) {
        // console.log("SEND FORM!");
        // this.disableAll = true;
        const data = {
          active: 1,
          firstName: this.userFirstNameCRUD,
          lastName: this.userLastNameCRUD,
          document: this.userDocumentCRUD,
          mobile: this.userPhoneNumberCRUD,
          about: this.userAboutCRUD
        };

        if (this.roleSelected < 2) {
          data.vicePr = this.userVicePCRUD;
          data.emailLF = this.userEmailLeaderCRUD.toLowerCase();
          data.emailAODS = this.userEmailAdminCRUD.toLowerCase();
          data.startDate = this.userStartDayCRUD;
          data.level = this.userLevelCRUD;
          data.area = this.userAreaCRUD;
          data.field = this.userFieldCRUD;
        }
        // console.log("DATA: ", data);
        this.createUser(data);
      } else console.log("VERIFY FORM!");
    }
  },
  created() {
    this.fetchUsers();
  }
};
</script>

<style lang="stylus" scoped>
.layout-all
  max-width 820px
.text-field-width
  max-width 360px
  min-width 360px
</style>
